import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { currentUser, loading, userRole } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Vérifier si l'utilisateur a le rôle requis
  // Direction RH a les mêmes droits que admin
  const effectiveRole = userRole === 'directionRH' ? 'admin' : userRole;
  if (allowedRoles.length > 0 && !allowedRoles.includes(effectiveRole)) {
    // Rediriger vers la page par défaut en fonction du rôle
    const defaultRoutes = {
      superAdmin: '/super-admin/establishments',
      admin: '/admin/personnel',
      directionRH: '/admin/personnel',
      chefService: '/chef-service/personnel',
      utilisateur: '/user/calendar'
    };
    return <Navigate to={defaultRoutes[userRole] || '/login'} />;
  }

  return children;
};

export default PrivateRoute;
